import { render } from "./Home.vue?vue&type=template&id=0ca1ac1e&bindings={\"projects\":\"data\"}"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"
script.render = render

export default script